// Every number on the page is clickable (brief §4.4). A zero is shown muted and not clickable,
// so the numbers that matter stand out.
import React from "react";
import styles from "../index.module.scss";

interface Props {
  value: React.ReactNode;
  count?: number; // when 0, renders as muted plain text
  onClick?: () => void;
  color?: string; // applied only when the count is non-zero
  title?: string;
  className?: string;
}

const MetricLink: React.FC<Props> = ({ value, count, onClick, color, title, className }) => {
  if (count === 0) {
    return (
      <span className={`${styles.metricZero} ${className ?? ""}`} title={title}>
        {value}
      </span>
    );
  }
  if (!onClick) {
    return (
      <span className={`${styles.metricStatic} ${className ?? ""}`} style={{ color }} title={title}>
        {value}
      </span>
    );
  }
  return (
    <button type="button" className={`${styles.metricLink} ${className ?? ""}`} style={{ color }} onClick={onClick} title={title}>
      {value}
    </button>
  );
};

export default MetricLink;
